import React, { useState } from 'react';
import {
    Menu,
    MenuItem,
    Typography,
    Button,
    Box,
    ListItemText
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditTwoProject from '../../../components/Projects/EditTwoProject';
import ArchiveProjects from '../../../components/Projects/ArchiveProjects';
export default function BatchActions() {

    const [openEditTwoProject, setOpenEditTwoProject] = useState(false);
    const [openArchiveProjects, setOpenArchiveProjects] = useState(false);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    return (
        <div className='d-flex align-items-center' style={{ gap: '8px' }}>
            <Box>
                <Button
                    onClick={handleClick}
                    endIcon={<ExpandMoreIcon />}
                    variant="outlined"
                    sx={{
                        background: '#fff',
                        borderRadius: '100px',
                        // color: '#0076FE',
                        // fontSize: '16px',
                        // fontWeight: '600',
                        textTransform: 'capitalize',
                        // height: '38px',
                        fontFamily: 'Manrope',
                        border: '1px solid #0076FE',
                        color: '#0084FF', fontSize: '14px',
                        fontWeight: '500', height: '36px',
                        '&:hover': {
                            background: '#fff'
                        }
                    }}
                >
                    Batch Actions
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ sx: { minWidth: 180, p: 0, borderRadius: '8px' } }}
                >

                    <MenuItem sx={{ fontFamily: 'Manrope' }} onClick={handleClose} disableRipple>
                        <ListItemText onClick={() => setOpenEditTwoProject(true)} variant="body1" sx={{ fontSize: '14px', fontFamily: 'Manrope', margin: '0 auto 12px', '& MuiTypography-root': { fontFamily: 'Manrope' } }}>Edit Project</ListItemText>
                    </MenuItem>
                    <MenuItem sx={{ fontFamily: 'Manrope' }} onClick={handleClose} disableRipple>
                        <ListItemText onClick={() => setOpenArchiveProjects(true)} variant="body1" sx={{ fontSize: '14px', fontFamily: 'Manrope', margin: '0 auto 12px', '& MuiTypography-root': { fontFamily: 'Manrope' } }}>Archive project</ListItemText>
                    </MenuItem>
                </Menu>
            </Box>
            <Box>
                <Typography sx={{ fontSize: '14px', fontWeight: '500', color: '#64748B', fontFamily: 'Manrope' }}>0/3 selected</Typography>
            </Box>
            <EditTwoProject open={openEditTwoProject} onClose={() => setOpenEditTwoProject(false)} />
            <ArchiveProjects open={openArchiveProjects} onClose={() => setOpenArchiveProjects(false)} />
        </div>
    );
}
